/**
 * API Service - Fetch wrapper with auth headers
 * Handles all communication with the backend
 */

import Auth from "./auth.js";

const API = {
  // Update this to your backend URL
  BASE_URL: "https://analytics.aiinenergy.com/api/",

  /**
   * Make an authenticated API request
   */
  async request(endpoint, options = {}) {
    const url = `${this.BASE_URL}${endpoint}`;
    const token = Auth.getToken();

    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    };

    try {
      const response = await fetch(url, {
        ...options,
        headers,
      });

      const data = await response.json();

      // Auto-logout on 401
      if (response.status === 401 && endpoint !== "login.php") {
        Auth.logout();
        return null;
      }

      if (!response.ok) {
        throw { status: response.status, ...data };
      }

      return data;
    } catch (error) {
      if (error.status) throw error;
      throw {
        success: false,
        message: "Network error. Please check your connection.",
      };
    }
  },

  /**
   * POST request
   */
  async post(endpoint, body) {
    return this.request(endpoint, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  /**
   * GET request
   */
  async get(endpoint) {
    return this.request(endpoint, {
      method: "GET",
    });
  },
};

export default API;
